import httpClient from "@/core/axios";
import queryString from "query-string";

export default {
    namespaced: true,
    state: {
        user: null,
        context: null
    },
    getters: {
        user(state) {
            return state.user;
        },
        context(state) {
            return state.context;
        }
    },
    actions: {
        loadAuthContext(context) {
            const auth_context = localStorage.getItem("auth_context");
            if (
                auth_context &&
                typeof auth_context === "string" &&
                auth_context !== ""
            ) {
                context.commit("SET_CONTEXT", JSON.parse(auth_context));
            }
        },
        async fetchUser(context) {
            if (context.state.context === null) {
                await context.dispatch("loadAuthContext");
            }
            await httpClient
                .get("/api/guest/auth/user")
                .then(data => context.commit("SET_USER", data))
                .catch(() => context.commit("SET_USER", null));

            return Promise.resolve();
        },
        async authWithSignature(context, query) {
            const params = queryString.parse(query);
            if (
                params.app_uuid &&
                params.user_uuid &&
                params.signature &&
                params.expires
            ) {
                await httpClient
                    .get("api/guest/auth/signature", {
                        params,
                        withoutUuidHeader: true
                    })
                    .then(data => {
                        context.commit("SET_CONTEXT", data);
                    });

                return Promise.resolve();
            }
            return Promise.reject();
        },
        async authWithCredentials(
            context,
            { booking_reference, email_or_phone }
        ) {
            await httpClient.get("sanctum/csrf-cookie");
            return httpClient
                .post(
                    "/api/guest/auth/credentials",
                    {
                        booking_reference,
                        email_or_phone
                    },
                    { withoutUuidHeader: true }
                )
                .then(data => context.commit("SET_CONTEXT", data));
        }
    },
    mutations: {
        SET_USER(state, data) {
            state.user = data;
        },
        SET_CONTEXT(state, data) {
            state.context = data;
            localStorage.setItem("auth_context", JSON.stringify(data));
        }
    }
};
